import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import OrderPaidMessage from "@/pages/checkout/CheckoutV2/components/OrderPaidMessage/OrderPaidMessage";
import ReservedMessage from "@/pages/checkout/CheckoutV2/components/ReservedMessage/ReservedMessage";
import BNPLMobileFormHeader from "@/pages/checkout/bnpl/common/components/BNPLMobileFormHeader";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import { OrderPaidError, PostReservedError } from "@/apis/orders/orders";
import { useTamaraFinance } from "@/common/Contexts/TamaraFinanceContext";
import { useTranslation } from "@i18n";
var TamaraFormLayout = function TamaraFormLayout(_ref) {
  var checkoutOrderV2 = _ref.checkoutOrderV2,
    fetch_loading = _ref.fetch_loading,
    fetch_error = _ref.fetch_error,
    orderData = _ref.orderData,
    isOtpStep = _ref.isOtpStep,
    showCancelPopup = _ref.showCancelPopup,
    children = _ref.children,
    onShowCancelPopup = _ref.onShowCancelPopup,
    onCancelPopupClose = _ref.onCancelPopupClose,
    onCancelPopupConfirm = _ref.onCancelPopupConfirm,
    onCancelPopupCancel = _ref.onCancelPopupCancel;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var post_id = useTamaraFinance().queryParams.post_id;

  // Handle loading state
  if (fetch_loading) {
    return /*#__PURE__*/React.createElement(Layout, {
      hideHeaderOnmobile: true,
      disableLoader: true,
      hideFooterWithoutAuthMsg: true,
      authenticationMsg: true,
      hideAppBanner: true,
      linksForSearch: true,
      mainClass: "AribFinancePage",
      headHideLinks: true,
      hideOrangeHeadBtn: true
    }, /*#__PURE__*/React.createElement(Loader, null));
  }

  // Handle error states - check for OrderPaidError and PostReservedError
  if (fetch_error) {
    if (fetch_error instanceof OrderPaidError) {
      return /*#__PURE__*/React.createElement(Layout, {
        hideHeaderOnmobile: true,
        disableLoader: true,
        hideFooterWithoutAuthMsg: true,
        authenticationMsg: true,
        hideAppBanner: true,
        linksForSearch: true,
        mainClass: "AribFinancePage",
        headHideLinks: true,
        hideOrangeHeadBtn: true
      }, /*#__PURE__*/React.createElement(OrderPaidMessage, {
        order_id: (orderData === null || orderData === void 0 ? void 0 : orderData.order_id) || ""
      }));
    } else if (fetch_error instanceof PostReservedError) {
      return /*#__PURE__*/React.createElement(Layout, {
        hideHeaderOnmobile: true,
        disableLoader: true,
        hideFooterWithoutAuthMsg: true,
        authenticationMsg: true,
        hideAppBanner: true,
        linksForSearch: true,
        mainClass: "TamaraFinancePage",
        headHideLinks: true,
        hideOrangeHeadBtn: true
      }, /*#__PURE__*/React.createElement(ReservedMessage, null));
    }
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: true,
    custommobileHeader: isMobile && /*#__PURE__*/React.createElement(BNPLMobileFormHeader, {
      hideBack: isOtpStep,
      isOtpStep: isOtpStep,
      onBack: function onBack() {
        return navigateTo(post_id ? "/pre-checkout?post_id=".concat(post_id) : "/pre-checkout");
      },
      title: tShort("tamara/page_title", {
        ns: "web_checkout_finance"
      })
    }),
    disableLoader: true,
    hideFooterWithoutAuthMsg: true,
    authenticationMsg: true,
    hideAppBanner: true,
    linksForSearch: true,
    mainClass: "TamaraFinancePage",
    headHideLinks: true,
    hideOrangeHeadBtn: true
  }, children);
};
export default TamaraFormLayout;